/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Figure_CaptionInputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_2_figure_caption = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Figure_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The formula bar and function tools help you inspect calculations. Screenshot: ArtCraft’s grade sample.`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_2_figure_caption = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Figure_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公式栏和函数工具可帮助检查计算逻辑。截图来源：ArtCraft 成绩示例。`)
};

/**
* | output |
* | --- |
* | "The formula bar and function tools help you inspect calculations. Screenshot: ArtCraft’s grade sample." |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Figure_CaptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_2_figure_caption = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Figure_CaptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Figure_CaptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_2_figure_caption(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_2_figure_caption(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_2_figure_caption as "gc.search_guides.gridcraft_excel_compatibility.sections.2.figure.caption" }